const campaignStatus = Object.freeze({
  NONE: 0,
  RUNNING: 1,
  CLOSED: 2,
  PAUSED: 3,
  STOPPED: 4
})

export { campaignStatus }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/CampaignStatusEnum.js